/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiCouponsApplyPut } from '../fn/coupons/api-coupons-apply-put';
import { ApiCouponsApplyPut$Params } from '../fn/coupons/api-coupons-apply-put';
import { apiCouponsApplyPut$Plain } from '../fn/coupons/api-coupons-apply-put-plain';
import { ApiCouponsApplyPut$Plain$Params } from '../fn/coupons/api-coupons-apply-put-plain';
import { apiCouponsDetachPut } from '../fn/coupons/api-coupons-detach-put';
import { ApiCouponsDetachPut$Params } from '../fn/coupons/api-coupons-detach-put';
import { apiCouponsDetachPut$Plain } from '../fn/coupons/api-coupons-detach-put-plain';
import { ApiCouponsDetachPut$Plain$Params } from '../fn/coupons/api-coupons-detach-put-plain';
import { Response } from '../models/response';

@Injectable({ providedIn: 'root' })
export class CouponsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiCouponsApplyPut()` */
  static readonly ApiCouponsApplyPutPath = '/api/coupons/apply';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCouponsApplyPut$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCouponsApplyPut$Plain$Response(params?: ApiCouponsApplyPut$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Response>> {
    return apiCouponsApplyPut$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCouponsApplyPut$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCouponsApplyPut$Plain(params?: ApiCouponsApplyPut$Plain$Params, context?: HttpContext): Observable<Response> {
    return this.apiCouponsApplyPut$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Response>): Response => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCouponsApplyPut()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCouponsApplyPut$Response(params?: ApiCouponsApplyPut$Params, context?: HttpContext): Observable<StrictHttpResponse<Response>> {
    return apiCouponsApplyPut(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCouponsApplyPut$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCouponsApplyPut(params?: ApiCouponsApplyPut$Params, context?: HttpContext): Observable<Response> {
    return this.apiCouponsApplyPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<Response>): Response => r.body)
    );
  }

  /** Path part for operation `apiCouponsDetachPut()` */
  static readonly ApiCouponsDetachPutPath = '/api/coupons/detach';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCouponsDetachPut$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCouponsDetachPut$Plain$Response(params?: ApiCouponsDetachPut$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Response>> {
    return apiCouponsDetachPut$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCouponsDetachPut$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCouponsDetachPut$Plain(params?: ApiCouponsDetachPut$Plain$Params, context?: HttpContext): Observable<Response> {
    return this.apiCouponsDetachPut$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Response>): Response => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCouponsDetachPut()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCouponsDetachPut$Response(params?: ApiCouponsDetachPut$Params, context?: HttpContext): Observable<StrictHttpResponse<Response>> {
    return apiCouponsDetachPut(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCouponsDetachPut$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiCouponsDetachPut(params?: ApiCouponsDetachPut$Params, context?: HttpContext): Observable<Response> {
    return this.apiCouponsDetachPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<Response>): Response => r.body)
    );
  }

}
